// Share actions for the context-menu rows (extracted from the retired social-share.vue).
// Browser-only: they touch `window` inside the call, never at import time.
const FACEBOOK_APP_ID = 126928420652882
const SHARE_WINDOW_FEATURES = 'width=400, height=300'

export function shareOnFacebook(url: string): void {
    window.open(
        `https://www.facebook.com/dialog/share?app_id=${FACEBOOK_APP_ID}&href=${url}`,
        'facebook Share Window',
        SHARE_WINDOW_FEATURES
    )
}

// Twitter is X now: the label reads 'X' and the intent URL is x.com. The window name
// keeps the old `twitter` value so nothing observable changes.
export function shareOnX(url: string, text: string): void {
    window.open(`https://x.com/intent/post?text=${encodeURIComponent(text)} ${url}`, 'twitter Share Window', SHARE_WINDOW_FEATURES)
}
